import { BaseEntityController } from "./baseEntityController";
import { EntityService } from "../services/entity-service";
import { ContractSharedDataService } from "../services/contract-shared-data-service";
import { LocalCacheService } from "../services/local-cache-service";
import { NotifyService } from "../services/notify-service";
import { AdminService } from "../services/admin-service";


export class BaseContractController extends BaseEntityController {
    selectedEntity: any;
    jobTitle: string;
    progressJobID: string;
    showJobProgressStatus: boolean;
    progressStatus: string;
    selectedEntityID: string;

    constructor(
        $scope: ng.IScope,
        entityService: EntityService,
        public sharedData: ContractSharedDataService,
        protected localStorage: LocalCacheService,
        notifyService: NotifyService,
        public adminService: AdminService,
        public $interval: ng.IIntervalService,
        $q: ng.IQService,
        public $location: ng.ILocationService,
        public $anchorScroll: ng.IAnchorScrollService) {

        super($scope, $q, entityService, localStorage, notifyService, $location, $anchorScroll);

        this.progressJobID = "";
        this.progressStatus = "";
        this.showJobProgressStatus = false;

    }
}